import { render, staticRenderFns } from "./CompareTOC.vue?vue&type=template&id=8841b99a"
import script from "./CompareTOC.vue?vue&type=script&lang=js"
export * from "./CompareTOC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports